function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u5730\u56FE");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-1126.000000, -390.000000)",
  fill: "#1B1464",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u65B9\\u5F0F",
  transform: "translate(1126.000000, 229.000000)"
}, React.createElement("path", {
  d: "M11.9844328,164 C7.57849111,164 4,167.370726 4,171.541054 C4,173.134557 4.52682734,174.614958 5.42090362,175.833799 C5.46547912,175.904321 5.50254617,175.972848 5.55643596,176.034056 L10.995693,182.499025 C11.2665676,182.836905 11.6264982,183 11.9863337,183 C12.3462643,183 12.7023931,182.838711 12.9750735,182.499025 L18.4126198,176.032345 C18.4626128,175.969046 18.5033866,175.90223 18.5423545,175.839311 C19.4402325,174.61857 19.9690558,173.140069 19.9690558,171.540959 C19.965254,167.370726 16.3923705,164 11.9844328,164 Z M11.9844328,174.557647 C10.2201363,174.557647 8.78991836,173.205174 8.78991836,171.541149 C8.78991836,169.875223 10.2202313,168.524841 11.9844328,168.524841 C13.7466385,168.524841 15.1788523,169.877219 15.1788523,171.541149 C15.1772365,173.205079 13.7466385,174.557647 11.9844328,174.557647 Z",
  id: "Shape"
}))));

var SvgAddress = function SvgAddress(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address.237e9c62.svg";
export { ForwardRef as ReactComponent };